import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { isVideoPlayingOptimistic } from 'widget/selectors/video-playback-status';
import { getMainVideoId } from 'widget/ui-selectors/selected-video-id';
import { getVideosInRowCount } from 'shared/selectors/app-settings';
import bi from 'shared/bi/bi';

import { DATA_KEY } from 'widget/data-components/paginated-channel-videos';

import ContentSlider from 'widget/components/content-slider/content-slider';
import PageList from 'widget/components/page-list/page-list';
import { NextButton, PrevButton } from 'widget/components/videos-list/nav-button/nav-button';
import VideoListItem from 'widget/views/desktop/classic/components/videos/video-list-item/video-list-item';

import styles from './videos.styl';


@connect(state => ({
  videoByIds: getVideosGroupedByIds(state),
  isVideoPlaying: isVideoPlayingOptimistic(state),
  selectedVideoId: getMainVideoId(state, DATA_KEY),
  videosInRow: getVideosInRowCount(state),
}))
@VODCSSModules(styles)
export default class Videos extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,

    channelData: React.PropTypes.object,

    containerWidth: React.PropTypes.number,

    videoByIds: React.PropTypes.object,
    videoIdsByPageNumber: React.PropTypes.array,

    thumbnailSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),

    videosInRow: React.PropTypes.number,
    videosPerPage: React.PropTypes.number,

    onSlideToPrev: React.PropTypes.func,
    onSlideToNext: React.PropTypes.func,
    onThumbnailClick: React.PropTypes.func,

    selectedVideoId: React.PropTypes.string,
    isSelectedVideoIndicationDisabled: React.PropTypes.bool,
    isVideoPlaying: React.PropTypes.bool,

    currentVideosPageNumber: React.PropTypes.number,
  };

  componentWillReceiveProps({ currentVideosPageNumber }) {
    if (currentVideosPageNumber !== this.props.currentVideosPageNumber) {
      bi.logWidgetSystem('videoList.changePage.rendered', { previousEventName: 'videoList.changePage.requested' });
    }
  }

  componentDidUpdate() {
    bi.logWidgetSystem('videoList.searchByQuery.rendered', {
      previousEventName: 'videoList.searchByQuery.requested',
    });
    bi.logWidgetSystem('videoList.searchByTag.rendered', {
      previousEventName: 'videoList.searchByTag.requested',
    });
    bi.logWidgetSystem('videoList.searchByCategory.rendered', {
      previousEventName: 'videoList.searchByCategory.requested',
    });
  }

  @autobind
  renderVideoItem(videoId, videoIndex) {
    const {
      channelData,
      videoByIds,
      thumbnailSize,
      onThumbnailClick,
      selectedVideoId,
      isSelectedVideoIndicationDisabled,
      isVideoPlaying,
      videosInRow,
    } = this.props;

    const videoItem = videoByIds[videoId];
    const isVideoSelected = selectedVideoId === videoId && !isSelectedVideoIndicationDisabled;
    const isLastInRow = (videoIndex + 1) % videosInRow === 0;

    return (
      <VideoListItem {...thumbnailSize}
                     onClick={onThumbnailClick}
                     channelData={channelData}
                     videoItem={videoItem}
                     isLastInRow={isLastInRow}
                     isSelected={isVideoSelected}
                     isPlaying={isVideoPlaying}
                     key={videoId} />

    );
  }

  hasPage(pageNum) {
    const { videoIdsByPageNumber } = this.props;
    return Boolean(videoIdsByPageNumber[pageNum]);
  }

  get isPrevPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber - 1);
  }

  get isNextPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber + 1);
  }

  render() {
    const {
      currentVideosPageNumber,
      videoIdsByPageNumber,
      containerWidth,
      className,
      onSlideToNext,
      onSlideToPrev,
    } = this.props;

    return (
      <section styleName="container"
               className={className}>
        <ContentSlider styleName="slider-container"
                       width={containerWidth}
                       currentPageNumber={currentVideosPageNumber}>
          <PageList pageWidth={containerWidth}
                    currentPageNumber={currentVideosPageNumber}
                    itemsByPageNumber={videoIdsByPageNumber}
                    renderItem={this.renderVideoItem} />
        </ContentSlider>
        <div styleName="buttons">
          <PrevButton disabled={!this.isPrevPageVisible}
                      onClick={onSlideToPrev} />
          <NextButton disabled={!this.isNextPageVisible}
                      onClick={onSlideToNext} />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/classic/components/videos/videos.js